import { DateTime } from 'luxon';

export const DEFAULT_TZ = 'Europe/Madrid';

const dt = (v: string | Date, tz = DEFAULT_TZ) => (typeof v === 'string' ? DateTime.fromISO(v, { zone: 'utc' }) : DateTime.fromJSDate(v)).setZone(tz).setLocale('es');

export const fmtTime = (v: string | Date | null | undefined, tz?: string) => (v ? dt(v, tz).toFormat('HH:mm') : '—');
export const fmtTimeSec = (v: string | Date | null | undefined, tz?: string) => (v ? dt(v, tz).toFormat('HH:mm:ss') : '—');
export const fmtDateTime = (v: string | Date | null | undefined, tz?: string) => (v ? dt(v, tz).toFormat('dd/MM/yyyy HH:mm') : '—');
export const fmtDate = (v: string | null | undefined) => (v ? DateTime.fromISO(v).setLocale('es').toFormat('dd/MM/yyyy') : '—');
export const fmtDateLong = (v: string | null | undefined) => {
  if (!v) return '—';
  const s = DateTime.fromISO(v).setLocale('es').toFormat("cccc, d 'de' LLLL");
  return s.charAt(0).toUpperCase() + s.slice(1);
};
export const fmtWeekdayShort = (v: string) => DateTime.fromISO(v).setLocale('es').toFormat('ccc d');
export const fmtMonth = (month: string) => {
  const s = DateTime.fromISO(`${month}-01`).setLocale('es').toFormat('LLLL yyyy');
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export function fmtMinutes(m: number | null | undefined, opts: { sign?: boolean } = {}) {
  if (m === null || m === undefined || Number.isNaN(m)) return '—';
  const sign = m < 0 ? '−' : opts.sign && m > 0 ? '+' : '';
  const a = Math.abs(Math.round(m));
  return `${sign}${Math.floor(a / 60)}h ${String(a % 60).padStart(2, '0')}m`;
}

export const fmtBytes = (b: number) => (b < 1024 ? `${b} B` : b < 1024 ** 2 ? `${(b / 1024).toFixed(1)} KB` : b < 1024 ** 3 ? `${(b / 1024 ** 2).toFixed(1)} MB` : `${(b / 1024 ** 3).toFixed(2)} GB`);

export const todayISO = (tz = DEFAULT_TZ) => DateTime.now().setZone(tz).toISODate()!;
export const monthISO = (tz = DEFAULT_TZ) => DateTime.now().setZone(tz).toFormat('yyyy-MM');
export const relative = (v: string) => DateTime.fromISO(v).setLocale('es').toRelative() ?? '';

export const fullName = (e: { firstName?: string | null; lastName?: string | null } | null | undefined) => (e ? `${e.firstName ?? ''} ${e.lastName ?? ''}`.trim() : '—');
export const initials = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]!.toUpperCase())
    .join('');
